import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Atto } from 'src/app/common/models/atto';

@Component({
  selector: 'app-atti-list-view',
  templateUrl: './atti-list-view.component.html',
  styleUrls: ['./atti-list-view.component.css']
})
export class AttiListViewComponent implements OnInit {


  @Input() atti: Atto[] = [];
  @Input() hasDeleteButton: boolean;
  @Input() hasEditButton: boolean;
  @Input() hasAssociaButton: boolean;
  @Input() associaDisabled: boolean;
  @Output() deleteEvent: EventEmitter<number> = new EventEmitter<number>();
  @Output() editEvent: EventEmitter<number> = new EventEmitter<number>();
  @Output() saveNewAttoEvent: EventEmitter<Atto> = new EventEmitter<Atto>();
  @Output() associaEvent: EventEmitter<Atto> = new EventEmitter<Atto>();
  activeIndex: number;


  constructor() { }

  ngOnInit() {
  }


  onDelete(index: number) {
    this.deleteEvent.emit(index);
  }

  onEdit(index: number) {
    this.editEvent.emit(index);
  }

  onSave(atto: Atto) {
    this.saveNewAttoEvent.emit(atto);
  }

  onAssocia(i: number) {
    this.associaEvent.emit(this.atti[i]);
  }

  openDetail(atto: Atto, indice: number) {
    if (this.activeIndex === undefined || this.activeIndex !== indice) {
      this.activeIndex = indice;
    } else {
      this.activeIndex = undefined;
    }
  }

}
